import { render, staticRenderFns } from "./VFatherPatAppointments.vue?vue&type=template&id=68b69629"
import script from "./VFatherPatAppointments.vue?vue&type=script&lang=js"
export * from "./VFatherPatAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports